'use client';

import type { DividerStyle, ReceiptSettings } from '@/lib/templates/schema';

interface SectionDividerProps {
  style: DividerStyle;
  settings: ReceiptSettings;
  className?: string;
}

// Get the character pattern for each divider style
function getDividerPattern(style: DividerStyle): string {
  switch (style) {
    case 'solid': return '─'; // Unicode box-drawing horizontal line
    case 'dashed': return '-';
    case 'dotted': return '·';
    case 'double': return '═';
    case 'equals': return '=';
    case 'dots': return '.';
    case 'colons': return ':';
    case 'stars': return '*';
    case 'spaces': return ' ';
    case 'none': return '';
    default: return '-';
  }
}

export function SectionDivider({ style, settings, className = 'mt-2' }: SectionDividerProps) {
  const pattern = getDividerPattern(style);
  const isNarrow = settings.spacing === 'narrow';
  
  if (!pattern || style === 'none') {
    return null;
  }

  // Add trailing spaces so any overflow clipping happens on invisible whitespace
  // instead of cutting a visible character in half
  const dividerContent = pattern.repeat(100) + '    ';
  
  return (
    <div
      className={isNarrow ? 'mt-0.5' : className}
      style={{
        fontFamily: settings.font,
        fontSize: settings.fontSize,
        color: settings.textColor,
        whiteSpace: 'nowrap',
        lineHeight: isNarrow ? 1.2 : 2.5,
        overflow: 'hidden',
      }}
    >
      {dividerContent}
    </div>
  );
}

